/** Mirrors middleware `_UPLOAD_ROLES` in app/api/routes/product_documents.py. */
export const UPLOAD_ROLES = ['admin', 'regulatory', 'operations', 'operations_logistics', 'purchasing'] as const

/** Roles with the `products` page key (app/rbac.py). */
export const VIEW_ROLES = [...UPLOAD_ROLES, 'sales'] as const
